import {
  baseTemplateConfigSchema,
  baseTemplateGeneralSchema,
} from "@anggunpraya-templates/base/app/schemas/template";
import { z } from "zod";

export const ap006TemplateProfileSocialSchema = z.object({
  label: z.string(),
  href: z.url(),
});

export const ap006TemplateGeneralSchema = baseTemplateGeneralSchema.extend({
  instagram: z.object({
    groom: ap006TemplateProfileSocialSchema,
    bride: ap006TemplateProfileSocialSchema,
  }),
});

export const templateConfigSchema = baseTemplateConfigSchema.extend({
  general: ap006TemplateGeneralSchema,
});

export type TemplateConfig = z.output<typeof templateConfigSchema>;

export function defineAp006TemplateConfig<TConfig extends TemplateConfig>(config: TConfig) {
  return templateConfigSchema.parse(config) as TConfig;
}
